/**
 * TenantBadge — small header badge showing the current school name.
 * Reads from useAuth().user.tenant_name populated by GET /v1/auth/me.
 */

import React from 'react';
import styled from 'styled-components';
import { useAuth } from '@/context';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: ${({ theme }) => theme.colors.backgroundTertiary};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  font-size: ${({ theme }) => theme.typography.fontSizes.xs};
  font-weight: ${({ theme }) => theme.typography.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.textSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primaryGradient};
  flex-shrink: 0;
`;

const TenantBadge: React.FC = () => {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <Badge data-testid="tenant-badge" title={user.tenant_name}>
      <Dot />
      {user.tenant_name}
    </Badge>
  );
};

export default TenantBadge;

